import MaterialTooltip, { TooltipProps } from '@mui/material/Tooltip';
import { CSSProperties } from 'react';

interface ITooltipProps extends TooltipProps {
    wrapperStyles?: CSSProperties;
}

export function Tooltip(props: ITooltipProps) {
    const { followCursor = true, wrapperStyles } = props;
    return (
        <MaterialTooltip
            followCursor={followCursor}
            data-testid={'Tooltip-container'}
            {...props}
        >
            <div style={wrapperStyles}>{props.children}</div>
        </MaterialTooltip>
    );
}

export default Tooltip;
